<template>
  <PHelpModal :title="title" :intro="intro" :steps="steps" :notes="notes"/>
</template>

<script>
import PHelpModal from "@/domain/core/components/PHelpModal.vue";

export default {
  name: "UserInferenceHelp",
  components: {PHelpModal},
  computed: {
    title() {
      return this.$pgettext('user_inference.help', 'How User Inference works')
    },
    intro() {
      return this.$pgettext('user_inference.help',
          'Sometimes new photos are uploaded after a guest already received theirs, or the selfie missed a few. ' +
          'This feature adds a "find more photos" action to the guest\'s gallery: the search is re-run using ' +
          'their best delivered photo as reference instead of the selfie.')
    },
    steps() {
      return [
        {
          title: this.$pgettext('user_inference.help', 'The guest requests more photos'),
          text: this.$pgettext('user_inference.help',
              'From the gallery, the guest taps the action to look for new photos. It is available only when all event uploads are completed and new photos arrived since the last search.')
        },
        {
          title: this.$pgettext('user_inference.help', 'The best delivered photo becomes the reference'),
          text: this.$pgettext('user_inference.help',
              'For each selfie, the system picks a good-quality face among the guest\'s delivered photos, preferring the one that looks least like the selfie to widen the search.')
        },
        {
          title: this.$pgettext('user_inference.help', 'The event photos are searched again'),
          text: this.$pgettext('user_inference.help',
              'The reference face is compared with all faces detected in the event photos, using a strict reliability threshold.')
        },
        {
          title: this.$pgettext('user_inference.help', 'New photos are delivered'),
          text: this.$pgettext('user_inference.help',
              'The matching photos are added to the guest\'s gallery. Only photos taken within the check-in validity period can be delivered.')
        }
      ]
    },
    notes() {
      return [
        this.$pgettext('user_inference.help',
            'Each guest can request this at most once every 24 hours.'),
        this.$pgettext('user_inference.help',
            'The search is bound to the guest\'s own check-in: found photos can never be delivered to someone else.'),
        this.$pgettext('user_inference.help',
            'It is a single direct search per selfie: no cluster or transitive expansion runs in this flow.')
      ]
    }
  }
}
</script>
